import { defaultsDeep } from "lodash";
import { Careseeker, DeepNullableObj } from "../types";
import { MockFn, createMock } from "./index";
import mockCareseekerModule from "./mockCareseekerModule";
import mockEvent from "./mockEvent";

const mockCareseeker: MockFn<Partial<DeepNullableObj<Careseeker>>> = (args) =>
  defaultsDeep(
    args,
    createMock(
      "Careseeker",
      args,
      (shallow): DeepNullableObj<Careseeker> => ({
        __typename: "Careseeker",
        activate_on_premise: null,
        address: {
          address: "Soldiner Str. 38",
          city: "Berlin",
          country: "DE",
          latitude: null,
          longitude: null,
          street: "Soldiner Str",
          street_number: "38",
          zipcode: "13359",
        },
        banking_details: {
          bank_name: "",
          iban: "",
          ik_number: "",
        },
        central_email: null,
        company: {
          force_id: "",
          id: 1,
          ik_numbers: null,
          name: "",
          status: null,
        },
        company_id: null,
        config: {
          activate_ahb_approver: false,
          activate_docs_redesign: false,
          activate_dta: false,
          activate_gateway_debug_mode: false,
          activate_parallel_search: false,
          activate_predict: false,
          activate_search_merge: false,
          activate_ssl_hl7_connector: false,
          auto_validate: false,
          deactivate_received_files: null,
          disable_seald: false,
          filter_on_social_worker: null,
          ip_range: "",
          jwt_expiration_in_minutes: null,
          kim_enabled: false,
          on_premise_archive_integration_enabled: null,
          on_premise_authorization_token: "",
          on_premise_domain_ssl: "",
          on_premise_file_sync: false,
          seald_config: null,
          seald_only_encryption: true,
          use_kis_integration: null,
          use_vzd_kim_address: null,
          whitelisted_email_domains: [],
          whitelisted_home_care_specializations: null,
          whitelisted_hospital_specializations: null,
          whitelisted_reha_specializations: null,
        },
        contact_name: "",
        contact_phone: "",
        created_at: null,
        events: mockEvent({ ...shallow("Event") }),
        external_id: null,
        force_id: "",
        id: 2,
        intercom_id: "",
        kim_address: null,
        modules: {
          care: mockCareseekerModule({ ...shallow("CareseekerModule") }),
          hospital: mockCareseekerModule({ ...shallow("CareseekerModule") }),
          medical_supplies: mockCareseekerModule({
            ...shallow("CareseekerModule"),
          }),
          psych_care: mockCareseekerModule({
            ...shallow("CareseekerModule"),
          }),
          reha: mockCareseekerModule({ ...shallow("CareseekerModule") }),
          transport: mockCareseekerModule({ ...shallow("CareseekerModule") }),
        },
        name: "Demo Clinic",
        notes: "",
        number_of_beds: null,
        on_premise_config: {
          __typename: "OnpremiseConfig",
          activate_ssl_hl7_connector: null,
          careseekers: null,
          config: { __typename: "Config" },
          id: null,
          name: null,
          on_premise_authorization_token: null,
          on_premise_domain_ssl: null,
          on_premise_file_sync: null,
          should_restart: null,
          token: null,
        },
        on_premise_config_id: null,
        patient_types: [],
        ppm_sender_id: null,
        priority_providers: [
          {
            __typename: "Careprovider",
            id: 1,
            name: "",
            onboarding: { status: null },
            patient_type: null,
            status: null,
          },
        ],
        product_features: [],
        seald_encryption_context: null,
        sender_user_management_file: null,
        site_id_number: null,
        sso_integration: null,
        stations: [],
        stations_full: [],
        status: null,
        type: null,
        updated_at: null,
      }),
    ),
  );

export default mockCareseeker;
